<template>
    <div class="user_total_container">
        <!-- <div class="titlediv">
            和信能源科技能效分析管理中心
        </div>
        <div class="data-box">
            <div class="data-box-item">
                <div class="data-box-item-title">平台接入用户</div>
                <div class="data-box-item-data">
                    <span class="data-box-item-data-val">{{
                        customer_count
                    }}</span>
                    <span class="data-box-item-data-unit">个</span>
                </div>
            </div>
            <div class="data-box-item">
                <div class="data-box-item-title">能效监测安装设备数</div>
                <div class="data-box-item-data">
                    <span class="data-box-item-data-val">{{
                        collector_count
                    }}</span>
                    <span class="data-box-item-data-unit">台</span>
                </div>
            </div>
            <div class="data-box-item">
                <div class="data-box-item-title">日能效监测电量总数</div>
                <div class="data-box-item-data">
                    <span class="data-box-item-data-val">{{
                        active_power_sum
                    }}</span>
                    <span class="data-box-item-data-unit">万kW·h</span>
                </div>
            </div>
        </div>-->

        <!-- <div class="sysType-box">
            <div class="sysType-box-wrap">
                <div class="sysType-box-wrap-item" @click="clickSysType(10)">
                    <img src="../../../assets/image/asset/ab5.png" alt />
                    <div
                        :class="[
                            isActive == 10 ? 'sysType-box-wrap-item-active' : ''
                        ]"
                    >能耗分析</div>
                </div>
                <div class="sysType-box-wrap-item" @click="clickSysType(20)">
                    <img src="../../../assets/image/asset/B6.png" alt />
                    <div
                        :class="[
                            isActive == 20 ? 'sysType-box-wrap-item-active' : ''
                        ]"
                    >微网监控</div>
                </div>
            </div>
        </div>-->
        <el-scrollbar style="height: calc(100% - 1rem)">
            <div class="table-wrap" v-show="isActive == 10">
                <div
                    :class="
                        currentCompanyId == item.login_name
                            ? 'table-item table-item-energy-width table-item-yes'
                            : 'table-item table-item-energy-width table-item-no'
                    "
                    v-for="(item, index) in company_list"
                    :key="index"
                    @click="doLogon(item)"
                >
                    <div class="table-item-top" style="text-align: center">
                        {{ item.cust_name }}
                        <i
                            class="el-icon-arrow-right"
                            style="margin-left: 2rem"
                        ></i>
                    </div>
                    <!-- <div class="table-item-bottom">
                        <div style="flex: 1" class="table-item-top">
                            变压器负载率：
                            <span style="color: #56fbff">
                                {{
                                    item.capacity
                                }}
                            </span>kVA&nbsp;(
                            <span style="color: #56fbff">
                                {{
                                    item.load_factor
                                }}
                            </span>%)
                        </div>
                    </div>
                    <div class="table-item-top">
                        最大需量：
                        <span style="color: #56fbff">
                            {{
                                item.month_maxdemand
                            }}
                        </span>
                        kW
                    </div>
                    <div class="table-item-top">
                        最大需量时间：
                        <span style="color: #56fbff">
                            {{
                                item.maxdemand_time
                            }}
                        </span>
                    </div>
                    <div class="table-item-top">
                        经济效益：
                        <span style="color: #56fbff">{{ item.economic }}</span>万元
                    </div>-->
                </div>
            </div>
            <div class="table-wrap" v-show="isActive == 20">
                <div
                    :class="
                        currentCompanyId == item.login_name
                            ? 'table-item table-item-width table-item-yes'
                            : 'table-item table-item-width table-item-no'
                    "
                    v-for="(item, index) in company_list"
                    :key="index"
                    @click="doLogon(item)"
                >
                    <div class="table-item-top">{{ item.cust_name }}</div>
                    <div class="table-item-bottom">
                        <img
                            src="../../../assets/image/asset/dianliang_bai.png"
                            v-if="currentCompanyId == item.login_name"
                        />
                        <img src="../../../assets/image/asset/dianliang.png" v-else />
                        <div style="flex: 1" class="table-item-top">
                            昨日电量：
                            <span style="color: #56fbff">
                                {{
                                    item.active_power_day
                                }}
                            </span>万kW·h
                        </div>
                    </div>
                    <div class="table-item-top">
                        发电量：
                        <span style="color: #56fbff">
                            {{
                                item.fdl
                            }}
                        </span>
                        万kW·h
                    </div>
                    <div class="table-item-top">
                        充电量：
                        <span style="color: #56fbff">
                            {{
                                item.cdl
                            }}
                        </span>
                        万kW·h
                    </div>
                    <div class="table-item-top">
                        经济效益：
                        <span style="color: #56fbff">
                            {{
                                item.jjxy
                            }}
                        </span>
                        元
                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
import * as api from "@/http/api-zmy.js";
export default {
    components: {},
    data() {
        return {
            searchForm: {
                cust_name: ""
            },
            pagination: {
                pageSize: 9999, //每页条数
                pageNum: 1, //当前页码
                totalNum: 0 //总条数
            },
            company_list: [],
            currentCompanyId: "",
            customer_count: "", //平台接入用户
            collector_count: "", //能效监测安装设备数
            active_power_sum: "", //日能效监测电量总数
            isActive: 10
        };
    },
    created() {
        this.clickSysType(10);
        // this.getUserTotalCount();
    },
    methods: {
        // 切换用户类型
        clickSysType(val) {
            this.isActive = val;
            this.company_list = [];
            if (val == 10) {
                this.getEnergyUserTotal();
            } else {
                this.getUserTotal();
            }
        },
        getUserTotalCount() {
            api.getUserTotalCount().then(res => {
                if (res && res.error_code === "0") {
                    this.customer_count = res.bus_json.customer_count;
                    this.collector_count = res.bus_json.collector_count;
                    this.active_power_sum = res.bus_json.active_power_sum;
                }
            });
        },
        getEnergyUserTotal() {
            api.getEnergyUserTotal().then(res => {
                if (res && res.error_code === "0") {
                    this.company_list = res.bus_json;
                }
            });
        },
        getUserTotal() {
            const param = {
                sys_type: this.isActive,
                ...this.searchForm,
                ...this.pagination
            };
            api.getUserTotal(param).then(res => {
                if (res && res.error_code === "0") {
                    this.company_list = res.bus_json.items;
                    //this.pagination.pageNum = res.bus_json.pageNum;
                    //this.pagination.totalNum = res.bus_json.totalNum;
                }
            });
        },
        doSearch() {
            this.getUserTotal();
        },
        handleCurrentChange(e) {
            this.pagination.pageNum = e;
            this.getUserTotal();
        },
        doLogon(item) {
            this.currentCompanyId = item.login_name;
            let routeUrl = this.$router.resolve({
                path: "/sign-on",
                query: { id: item.login_name }
            });
            // this.$store.commit("IS_CHANGE_SYSTEM", true);
            localStorage.setItem("changeCustom", "1");
            window.open(routeUrl.href, "_blank");
        }
    }
};
</script>
<style lang="scss">
.user_total_container {
    padding: 0 0 0 2rem;
    font-size: 0.8rem;
    height: 100%;
    text-align: center;
    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .titlediv {
        color: #fff;
        text-align: center;
        font-size: 1.5rem;
    }
    .data-box {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        margin-bottom: 20px;
        &-item {
            height: 100px;
            width: 350px;
            line-height: 80px;
            border: 1px solid #fff;
            border-radius: 5px;
            font-size: 20px;
            color: #fff;
            &-title {
                height: 50px;
                line-height: 50px;
            }
            &-data {
                height: 50px;
                line-height: 50px;
                margin-top: -10px;
                &-val {
                    display: inline-block;
                    margin-right: 5px;
                    font-size: 30px;
                    color: #fff;
                }
            }
        }
    }
    .sysType-box {
        width: 100%;
        text-align: center;
        height: 110px;
        //  margin-bottom: 20px;
        border-bottom: 1px solid #fff;
        &-wrap {
            margin: 0 auto;
            width: 30%;
            height: 90px;
            display: flex;
            justify-content: space-around;
            &-item {
                height: 100%;
                width: 100px;
                color: #fff;
                cursor: pointer;
                img {
                    width: 70px;
                    height: 70px;
                    margin-bottom: 10px;
                }
                &-active {
                    color: #52f2f6;
                }
            }
        }
    }
    .space_between {
        display: flex;
        justify-content: space-between;
    }
    .el-form-item {
        margin-bottom: 0 !important;
    }
    .table-wrap {
        display: flex;
        flex-flow: row wrap;
        //justify-content: space-between;
        //height: 140px;
        background: none;
        .table-item-width {
            width: 10.5rem;
        }
        .table-item-energy-width {
            // width: 15.5rem;
            width: 30%;
        }
        .table-item {
            border-radius: 0.8rem;
            padding: 0.8rem 0.6rem;
            text-align: left;
            cursor: pointer;
            margin: 1rem 0.75rem 0 0.75rem;
            height: fit-content;
            .table-item-top {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-top: 8px;
            }
            .table-item-bottom {
                display: flex;
                align-items: center;
                margin-top: 0.6rem;
                img {
                    height: 1rem;
                    width: auto;
                    margin-right: 0.5rem;
                }
            }
        }
    }
    .table-item-no {
        // border: 1px solid #87cff0;
        // color: #000;
        // background-color: #f4f4f4;
        border: 1px solid #87cff0;
        color: #fff;
        background-color: rgba(29, 51, 95, 0.7);
    }
    .table-item-yes {
        // border: 1px solid #87cff0;
        // color: #fff;
        // background-color: #9fb5e1;
        border: 1px solid #87cff0;
        color: #00ffff;
        background-color: #002e73;
    }
}
@media screen and (max-width: 1366px) {
    .table-wrap {
        max-height: 28rem !important;
        .table-item-width {
            width: 12rem !important;
        }
        .table-item-energy-width {
            width: 17rem !important;
        }
    }
}
@media screen and (max-width: 1440px) and (min-width: 1367px) {
    .table-wrap {
        max-height: 36rem !important;
        .table-item-width {
            width: 12.5rem !important;
        }
        .table-item-energy-width {
            width: 17rem !important;
        }
    }
}
@media screen and (max-width: 1680px) and (min-width: 1441px) {
    .table-wrap {
        max-height: 40rem !important;
        .table-item-width {
            width: 12.5rem !important;
        }
        .table-item-energy-width {
            width: 17rem !important;
        }
    }
}
</style>
